import * as React from 'react';

function Clock(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 20a8 8 0 100-16 8 8 0 000 16zm6.588-8a6.588 6.588 0 11-13.176 0 6.588 6.588 0 0113.176 0zm-5.882-4.706a.706.706 0 00-1.412 0v4.998l.207.207 2.353 2.353a.706.706 0 00.998-.998l-2.146-2.146V7.294z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Clock;
